<template>
  <div class="inquiry-list-page">
    <!-- search -->
    <div class="search">
      <el-form
        ref="form"
        :model="query"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="承兑人名称：">
          <el-input v-model="query.acceptor" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单日期：">
          <el-date-picker
            v-model="date"
            type="daterange"
            size="mini"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- result -->
    <div class="result-wrapper">
      <card
        v-for="(item, index) in data"
        :key="index"
        :data="item"
        :has-create-date="true"
      ></card>
    </div>
    <!-- No data -->
    <div
      class="result-wrapper"
      v-if="(data || []).length === 0"
      style="background: #fff;"
    >
      <no-data></no-data>
    </div>
    <!-- paging -->
    <el-pagination
      class="pagination"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="page.page"
      :page-size="page.size"
      @current-change="changePage"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixin from "@/mixins//list";
import NoData from "@/components/NoData";
import OrderCard from "@/components/OrderCard/Card2";

export default {
  mixins: [mixin],
  components: {
    "no-data": NoData,
    card: OrderCard
  },
  data() {
    return {
      query: {
        // queryorderid: "",
        acceptor: "",
        create_startdate: "",
        create_enddate: ""
      },
      date: "",
      data: []
    };
  },
  created() {
    this.search();
  },
  watch: {
    // "query.queryorderid"() {
    //   this.search();
    // },
    "query.acceptor"() {
      this.search();
    }
  },
  methods: {
    search() {
      const param = {
        ...this.query,
        ...this.page
      };
      this.$request.inquiry_list(param).then(res => {
        const { code = -1, msg = "", listData = {} } = res;

        if (code !== 0) {
          this.data = [];
          this.$message.error(msg);
          return;
        }

        const { totalRow = 0, list = [] } = listData || {};

        this.data = list || [];
        this.total = totalRow;
      });
    },

    changeDate(date) {
      if (date) {
        this.query.create_startdate = date[0];
        this.query.create_enddate = date[1];
      } else {
        this.query.create_startdate = "";
        this.query.create_enddate = "";
      }

      this.search();
    },

    // 翻页
    changePage(current) {
      this.page.page = current;
      this.search();
    }
  }
};
</script>
